import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration } from 'src/app/app.constants';
import { UnitTypeViewModel } from '../../sustainability/viewModels/unitTypeViewModel';
import { UnitViewModel } from '../../sustainability/viewModels/unitViewModel';
import { map, Observable } from 'rxjs';
import { UnitDataSources } from '../../sustainability/enums/unitDataSources';

@Injectable({
  providedIn: 'root',
})
export class UnitsService {

  constructor(private http: HttpClient, private configuration: Configuration) {
    
  }

  /**
   * Getter that dynamically builds the actionUrl each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get actionUrl(): string {
    return this.configuration.buildEndpoint(`Units/`);
  }

  getUnitTypes(includeUnits: boolean = false): Observable<UnitTypeViewModel[]> {
    return this.http.get<UnitTypeViewModel[]>(`${this.actionUrl}unitTypes/${includeUnits.toString()}`);
  }

  /// Get unit types that are excluded from dropdown visibility
  getUnitTypeIdsExcludedFromDropdowns(): Observable<number[]> {
    return this.getUnitTypes().pipe(
      map(unitTypes => unitTypes
        .filter(unitType => unitType.dataSource === UnitDataSources.Climatiq)
        .map(unitType => unitType.id)
      )
    );
  }

  getUnits(): Observable<UnitViewModel[]> {
    return this.http.get<UnitViewModel[]>(`${this.actionUrl}units`);
  }
}
